module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_7016.b280f1eb.png";